import { marked } from 'marked';
import { Text, View, StyleSheet, Font, Document, Page, Image } from '@react-pdf/renderer';
import type { TokensList } from 'marked';
import notoSansTCFont from "assets/NotoSansTC-Regular.ttf"
import blackwhiteLogo from 'assets/blackwhiteLogo.png'



// 定義基本樣式
// Register Font
Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf"
});
Font.register({
  family: "Noto Sans TC",
  src: notoSansTCFont
});


const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    fontFamily: "Noto Sans TC"
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    // fontFamily: 'Oswald'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    // fontFamily: 'Oswald'
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'justify',
    // fontFamily: 'Times-Roman'
  },
  image: {
    // width: 200,
    marginVertical: 15,
    marginHorizontal: 200,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  paragraph: {
    marginBottom: 10,
    fontSize: 12,
  },
  heading1: {
    marginTop: 20,
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  heading2: {
    marginTop: 14,
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  heading3: {
    marginTop: 14,
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  listItem: {
    fontSize: 12,
    marginLeft: 10,
    marginTop: 8,
    marginBottom: 5,
  }
});


export class MarkdownToPdfService {
  static convertToMedicalReport(markdown: string) {
    const tokens = marked.lexer(markdown);
    return (

      <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.header} fixed>
            - 麻醉安全通 -
          </Text>
          <Text style={styles.title}>AI 醫療報告</Text>
          <Text style={styles.header}>僅做為參考，實際診斷與行動應與醫師討論。</Text>
          <Image
            style={styles.image}
            src={blackwhiteLogo}
          />
          {
            this.tokensToComponents(tokens)
          }

          <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages} \n - 僅做為參考，實際診斷與行動應與醫師討論。 -`
          )} fixed />
        </Page>
      </Document>
    );
  }

  private static tokensToComponents(tokens: TokensList) {
    return tokens.map((token, index) => {
      let text = '';
      switch (token.type) {
        case 'paragraph':
          // 處理文本中的粗體標記
          text = token.text
            .replace(/\*\*(.*?)\*\*/g, '$1') // 去除粗體符號
            .replace(/，/g, '， ') // 逗號後加空格，為了讓中文也可以自動換行
            .replace(/；/g, '； ')
            .replace(/、/g, '、 ')
            .replace(/。/g, '。 '); // 句號後加空格
          return (
            <Text key={index} style={styles.paragraph}>
              {text}
            </Text>
          );

        case 'heading':
          const headingStyle = this.getHeadingStyle(token.depth);
          return (
            <Text key={index} style={headingStyle}>
              {token.text}
            </Text>
          );

        case 'list':
          return (
            <View key={index}>
              {token.items.map((item: any, itemIndex: any) => (
                <Text key={itemIndex} style={styles.listItem}>
                  {
                    item.raw
                      .replace(/\*\*(.*?)\*\*/g, '$1') // 去除粗體符號
                      .replace(/，/g, '， ') // 逗號後加空格，為了讓中文也可以自動換行
                      .replace(/；/g, '； ')
                      .replace(/、/g, '、 ')
                      .replace(/。/g, '。 ') // 句號後加空格
                  }
                </Text>
              ))}
            </View>
          );

        default:
          return null;
      }
    });
  }

  private static getHeadingStyle(depth: number) {
    switch (depth) {
      case 1:
        return styles.heading1;
      case 2:
        return styles.heading2;
      case 3:
        return styles.heading3;
      default:
        return styles.paragraph;
    }
  }
}